import { PhotoshopController } from "../photoshopController.js";
import * as glMatrix from 'gl-matrix';

export class GlWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    _canvas: HTMLCanvasElement;
    _gl: any;
    constructor(parentElement: HTMLElement, controller: PhotoshopController) {
        this.parentElement = parentElement;
        this.photoshopController = controller;
        const canvas = document.getElementById('WebGL');
        if (!canvas) {
            throw 'Failed to get WebGL Canvas';
        }
        this._canvas = canvas as HTMLCanvasElement;
        //this.resize();
        this._gl = this._canvas.getContext('webgl2', { antialias: true, premultipliedAlpha: false });

        if (!this._gl) {
            throw 'Failed to init WebGL context';
        }

        const color_buffer_float_ext = this._gl.getExtension("EXT_color_buffer_float");
        if (!color_buffer_float_ext) {
            throw 'Failed to init EXT_color_buffer_float extension';
        }

        this._canvas.addEventListener('pointerdown', function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.photoshopController.pointerDownHandler(event);
        }.bind(this));

        this._canvas.addEventListener('pointermove', function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.photoshopController.PSMoveEvent = event;
            var position = glMatrix.vec2.fromValues(event.offsetX / event.currentTarget.clientWidth, event.offsetY / event.currentTarget.clientHeight);
            this.photoshopController.PSEngine.position = position;
            this.photoshopController.handleMoveEvent();

            if (!this.photoshopController.PSRequestAnimationFrameId) {
                this.photoshopController.PSEngine.render(this.photoshopController.PSCamera);
            }
        }.bind(this));

        this._canvas.addEventListener('wheel', function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (!event.shiftKey) {
                this.photoshopController.PSCamera.start('ZOOM', this._canvas.width, this._canvas.height, event);
                this.photoshopController.PSCamera.wheel(event);
                this.photoshopController.PSCamera.end();
            } else {
                if (!this.photoshopController.PSEngine.activeLayer.hasToolOperation) {
                    this.photoshopController.PSEngine.activeLayer.camera.start('ZOOM', this._canvas.width, this._canvas.height, event);
                    this.photoshopController.PSEngine.activeLayer.camera.wheel(event);
                    this.photoshopController.PSEngine.activeLayer.camera.end();
                }
            }
            this.photoshopController.update();
        }.bind(this));

    }

    get gl() {
        return this._gl;
    }

    get canvas() {
        return this._canvas;
    }

    static html() {
        return `
        <div id="WebGLContainer"
        style="width: calc(100% - 500px); float:left; position: relative; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)">
        <canvas id="WebGL" style="width: 100%; height: 100%; background-color: transparent;"></canvas>
        <div id="reglages"
            style="position: absolute; top: 0; right: 0; width: 350px; background-color: #535353AA;">            
        </div>
        </div>
        `;
    }

    resize() {
        var webGlContainer = document.getElementById('WebGLContainer');
        if (webGlContainer) {
            this._canvas.width = webGlContainer.clientWidth;
            this._canvas.height = webGlContainer.offsetParent ? webGlContainer.offsetParent.clientHeight : webGlContainer.clientHeight;
            this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
        }
    }
}